/*
 * Author: Dw
 * File Created: Monday, 25-06-16 10:36
 * Last Modified: Friday, 25-06-27 03:02 pm, by Dw
 */
import type { InstanceMap } from '../strategy';
import type { ICaptchaInstance, ICaptchaProvider } from '../types';

const GT_SCRIPT = 'https://static.geetest.com/v4/gt4.js?skipSW';

function injectScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${GT_SCRIPT}"]`)) {
      resolve();

      return;
    }

    const s = document.createElement('script');

    s.src = GT_SCRIPT;
    s.async = true;
    s.onload = () => {
      resolve();
    };

    s.onerror = () => {
      reject(new Error('gt4.js load fail'));
    };

    document.head.appendChild(s);
  });
}

export interface GeetestInstance extends ICaptchaInstance {
  /** 极验原生实例，拥有 appendTo/onReady/getValidate 等方法 */
  captchaGeeTestObj: GeetestCaptcha;
}

class GeetestWrapper implements GeetestInstance {
  constructor(public captchaGeeTestObj: GeetestCaptcha) {}

  show() {
    this.captchaGeeTestObj.showCaptcha();
  }

  reset() {
    this.captchaGeeTestObj.reset();
  }

  destroy() {
    this.captchaGeeTestObj.destroy();
  }
}

export const geetestProvider: ICaptchaProvider = {
  /**
   * @param captchaId 极验后台生成的 Captcha ID
   * @param product   bind | float | popup（默认 bind）
   */
  async init({
    captchaId,
    product = 'bind',
    ...rest
  }): Promise<InstanceMap['GEETEST']> {
    if (!captchaId) throw new Error('captchaId is required for Geetest');
    await injectScript();

    return new Promise<GeetestInstance>((resolve) => {
      window.initGeetest4?.(
        { captchaId, product, protocol: 'https://', ...rest },
        (obj) => {
          resolve(new GeetestWrapper(obj));
        },
      );
    });
  },
};
